import { writable } from 'svelte/store';
import { initDB, countStore } from '../lib/db/indexeddb.js';

export const localDBState = writable({
  isReady: false,
  encrypted: true,
  channelCount: 0,
  videoCount: 0,
  lastImportedAt: null
});

export async function refreshLocalCounts() {
  const db = await initDB();
  const channelCount = await countStore(db, 'channels');
  const videoCount = await countStore(db, 'videos');
  localDBState.update((state) => ({
    ...state,
    isReady: true,
    channelCount,
    videoCount
  }));
}

export function setLastImportedAt(value) {
  localDBState.update((state) => ({
    ...state,
    lastImportedAt: value
  }));
}
